import { render, staticRenderFns } from "./TrafficAnalytics.vue?vue&type=template&id=4e0070ab&scoped=true"
import script from "./TrafficAnalytics.vue?vue&type=script&lang=js"
export * from "./TrafficAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TrafficAnalytics.vue?vue&type=style&index=0&id=4e0070ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0070ab",
  null
  
)

export default component.exports